import React from 'react';

const IconCheck = props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M9.85928 18.2499H9.86009H9.87009V18.2499L9.87319 18.2499C10.0455 18.2477 10.2155 18.21 10.3726 18.139C10.5293 18.0681 10.6698 17.9657 10.7851 17.838C10.7853 17.8378 10.7855 17.8376 10.7857 17.8374L19.9203 7.84333C20.0395 7.72504 20.1336 7.58392 20.1971 7.42839L19.9657 7.33392L20.1971 7.42839C20.2615 7.27064 20.293 7.1014 20.2895 6.93105C20.2861 6.7607 20.2479 6.59285 20.1773 6.4378C20.1067 6.28275 20.0051 6.14379 19.8788 6.02943C19.7525 5.91508 19.6041 5.82775 19.4428 5.77281C19.2815 5.71788 19.1107 5.69649 18.9409 5.70997C18.771 5.72345 18.6057 5.77151 18.4552 5.8512C18.307 5.92958 18.1762 6.03691 18.0705 6.16681L9.84767 15.162L5.91239 10.9688C5.68535 10.7269 5.37149 10.585 5.03985 10.5745C4.70822 10.5639 4.38598 10.6856 4.14402 10.9126C3.90206 11.1396 3.7602 11.4535 3.74966 11.7851C3.73911 12.1168 3.86074 12.439 4.08778 12.681L4.08793 12.6811L8.94678 17.8499C8.94699 17.8501 8.9472 17.8504 8.94741 17.8506C9.06384 17.9759 9.20476 18.0761 9.36146 18.1448C9.51844 18.2136 9.68789 18.2494 9.85928 18.2499Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </svg>
  );
};

const MemoIconCheck = React.memo(IconCheck);
export default MemoIconCheck;
